import _ from 'lodash';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Layout, Dropdown, Menu, Input, message, Button } from 'antd';

import Emitter from '../../services/emitter';

import { showErrorMessage } from '../../util';
import CONSTANT from '../../constant';

import ProjectApi from '../../services/api/project';

import './header.less';
import './header.editor.pc.less';
import History from '../../util/history';

class HeaderEditorPC extends React.Component {
    constructor(props) {
        super(props);
        const { project, intlr } = props;
        this.state = {
            value: project.name || ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects),
            isFocusInput: false,
            isLocalFile: false
        };
    }

    componentDidMount() {
        const { project } = this.props;
        this.setState({
            isLocalFile: project.projectType === CONSTANT.PROJECT_TYPE.LOCAL
        });
    }

    componentWillReceiveProps(nextProps) {
        const { project, intlr } = nextProps;
        let newProjectName = project.name || intlr.messages['FILENAME.EMPTY'];

        // 示例，需要走新项目名+1
        if (CONSTANT.PROJECT_TYPE.EXAMPLE === project.projectType) {
            newProjectName = ProjectApi.getNewProjectName(newProjectName, project.projects);
        }
        // 新建，未命名时走新项目名+1
        if ('' === project.projectType) {
            newProjectName = project.name || ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects);
        }

        if (project.name !== newProjectName) {
            Emitter.emit('RenameRuntime', newProjectName);
        }
        this.setState({
            value: newProjectName,
            isLocalFile: project.projectType === CONSTANT.PROJECT_TYPE.LOCAL
        });
    }

    /**
     * 返回按钮
     * @author Zhangkun
     */
    backGo() {
        return (
            <Button
                className="editor-header-back"
                onClick={this.handleBackGoClick}>
                <i className={`mblock-icon icon-fanhui`}></i>
            </Button>
        );
    }

    /**
     * 保存下拉框
     * @author Zhangkun
     */
    saveList() {
        const { project } = this.props;
        const isDisabled = project.projectStatus === CONSTANT.PROJECT_STATUS.WILL_DOWNLOAD;
        return (
            <Dropdown
                disabled={isDisabled}
                overlay={this.saveMenuList()}
                placement="bottomLeft"
                trigger={['hover']}>
                <Button
                    className="editor-header-save-button">
                    <i className={`mblock-icon icon-baocun`}></i>
                </Button>
            </Dropdown>
        );
    }

    /**
     * 保存返回信息
     */
    saveMessage() {
        const { intlr, project } = this.props;
        const { saveStatus } = project;
        switch (saveStatus) {
            case CONSTANT.PROJECT_SAVE_STATUS.SUCCESS:
                return (<span className="editor-header-save-success">{intlr.messages['MENU.FILE.SAVE.SUCCESS']}</span>);
            case CONSTANT.PROJECT_SAVE_STATUS.FAILURE:
                return (<span className="editor-header-save-failure">{intlr.messages['MENU.FILE.SAVE.FAIL']}</span>);
            case CONSTANT.PROJECT_SAVE_STATUS.DOING:
                return (<span className="editor-header-saving">{intlr.messages['MENU.FILE.SAVEING']}</span>);
            default:
                return '';
        }
    }

    saveMenuList() {
        const { intlr } = this.props;
        const { isLocalFile } = this.state;
        const saveasItemKey = isLocalFile ? 'MENU.FILE.SAVEAS' : 'MENU.FILE.SAVEASTOMY';
        return (
            <Menu
                className="editor-header-save-list-menu"
                onClick={this.handleSaveListMenuClick}>
                <Menu.Item key="MENU.FILE.SAVE">{intlr.messages['MENU.FILE.SAVE']}</Menu.Item>
                <Menu.Item key={saveasItemKey}>{intlr.messages['MENU.FILE.SAVEAS']}</Menu.Item>
                {isLocalFile ? <Menu.Item key="MENU.FILE.SAVEMY">{intlr.messages['MENU.FILE.SAVEMY']}</Menu.Item> : ''}
            </Menu>
        );
    }

    changeToTab = () => {
        const { project } = this.props;
        const { projectType } = project;
        switch (projectType) {
            case CONSTANT.PROJECT_TYPE.LOCAL:
                return 'fs';
            case CONSTANT.PROJECT_TYPE.LIST:
            case CONSTANT.PROJECT_TYPE.EXAMPLE:
            default:
                return 'yun';
        }
    };

    handleSaveListMenuClick = (item) => {
        const { value } = this.state;

        switch (item.key) {
            case 'MENU.FILE.SAVE':  // 保存
                Emitter.emit('SaveProject', false, this.changeToTab(), { name: value });
                break;
            case 'MENU.FILE.SAVEAS':    // 另存为 文件系统
                Emitter.emit('SaveProject', true, 'fs');
                break;
            case 'MENU.FILE.SAVEASTOMY':  // 另存为 我的作品
                History.replace(`/project/saveas/my/${value}`);
                break;
            case 'MENU.FILE.SAVEMY':   // 保存到我的作品
                History.replace(`/project/saveas/tomy/${value}`);
                break;
            default:
                break;
        }
    };

    handleBackGoClick = () => {
        const { saveStatus } = this.props.project;
        if (saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
            return;
        }
        Emitter.emit('ClickMenu', 'MENU.BACKGO');
    };

    /**
     * 项目名称
     *
     * @author LiHuan
     * @returns
     */
    projectName() {
        const { project } = this.props;
        const { name, projectStatus } = project;
        const { value } = this.state;
        const isDisabled = projectStatus === CONSTANT.PROJECT_STATUS.WILL_DOWNLOAD;
        return (
            <Input className="input-rename"
                ref={rinput => this.renameInput = rinput}
                defaultValue={name}
                value={value}
                disabled={isDisabled}
                onChange={e => this.handleRenameChange(e.target.value)}
                onPressEnter={this.handlePressEnter.bind(this)}
                onClick={this.handleRenameFocus.bind(this)}
                onBlur={e => this.handleRename(e.target.value)}
                autoComplete="off" />
        );
    }

    handleRenameFocus() {
        this.setState({ isFocusInput: true });
        this.renameInput.input.select();
    }

    handlePressEnter() {
        this.renameInput.input.blur();
    }

    handleRenameChange(value) {
        if (_.trim(value).length > 48) {
            showErrorMessage.bind(this)('PROJECT.NAME.MAX.LENGTH.TEXT');
            value = value.substring(0, 48);
        }
        this.setState({ value });
    }

    handleRename(value) {
        const { project, intlr } = this.props;
        const { id, projectType, projectStatus, projectId } = project;
        let name = _.trim(value);
        const createdAt = Date.parse(new Date()) / 1000;
        this.setState({
            isFocusInput: false,
            value: name
        });
        if (_.isEmpty(name)) {
            showErrorMessage.bind(this)('RENAME.ERR.NULL.MSG');
            return this.setState({
                value: project.name || ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects)
            });
        }

        if (_.indexOf([CONSTANT.PROJECT_TYPE.EXAMPLE, ''], projectType) > -1) {
            return Emitter.emit('RenameRuntime', name);
        }
        if (CONSTANT.PROJECT_TYPE.LOCAL !== projectType) {
            return Emitter.emit('RenameProject', { id, projectName: name, createdAt, projectId, syncStatus: projectStatus }, 'yun');
        }
        const headReg = /^[-+\.]+/;

        if (headReg.test(name)) {
            showErrorMessage.bind(this)('RENAME.ERR.PREFIX.MSG');
            this.setState({ value: project.name });
            return;
        }
        const charReg = /[\^\\%&/*~'/?///</>/|/"/(/)/$#,@:;&]+/;
        if (charReg.test(name)) {
            showErrorMessage.bind(this)('RENAME.ERR.CONTAIN.MSG');
            this.setState({ value: project.name });
            return;
        }
        const stringReg = /(^(con)$)|^(con)[/.\s]*\.|(^(prn)$)|^(prn)[/.\s]*\.|(^(aux)$)|^(aux)[/.\s]*\.|(^(nul)$)|^(nul)[/.\s]*\.|(^(com)[1-9]$)|^(com)[1-9]\..*|(^(lpt)[1-9]$)|^(lpt)[1-9][/.\s]*\./;
        if (stringReg.test(name)) {
            const matchStr = value.match(/con|prn|aux|nul|com[1-9]|lpt[1-9]]/)[0];
            message.error(matchStr + intlr.messages['RENAME.ERR.KEY.MSG']);
            this.setState({ value: project.name });
            return;
        }
        if (name !== project.name) {
            if (!_.isEmpty(name)) {
                Emitter.emit('RenameProject', { name }, 'fs', (err) => {
                    if (err && err.code === -2) {
                        message.error(intlr.messages['RENAME.ERR.EXIST.MSG']);
                        return this.setState({ value: project.name });
                    }
                });
            } else {
                name = project.name;
            }
        }
        this.setState({
            value: name
        });
    }

    render() {
        const { isFocusInput, isLocalFile } = this.state;
        const { intlr } = this.props;
        return (
            <Layout.Header className="header">
                <section className="header-cell main-menu-cell">
                    {this.backGo()}
                </section>
                <section className="header-cell project-name-cell">
                    {this.projectName()}
                    {!isFocusInput && this.saveList()}
                    {this.saveMessage()}
                </section>
                <section className="header-cell user-menu-cell">
                    <span className="editor-header-right">{isLocalFile && intlr.messages['MENU.FILE.LOCALFILE']}</span>
                </section>
            </Layout.Header>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    project: state.project
});

export default withRouter(connect(
    mapStateToProps
)(HeaderEditorPC));